/**
 * @public
 * @function getDonationSubtotal
 * @description gets the donations subtotal for the receipt
 * @param {object} receipt the receipt data that is stored in redux
 * @returns {number} the donations subtotal for the receipt
 */
export const getDonationSubtotal = (receipt = {}) => {
    const { transaction = {} } = receipt;
    const { donations = [] } = transaction;
    let subtotal = 0;

    // P2P registration forms can only be associated with a single optional
    // donation amount at this point
    if (Array.isArray(donations) && donations.length > 0) {
        subtotal = donations[0].amount;
    }

    return subtotal;
};

/**
 * @public
 * @function getRegistrationSubtotal
 * @description gets the registration subtotal for the receipt
 * @param {object} receipt the receipt data that is stored in redux
 * @returns {number} the event registration subtotal for the receipt
 */
export const getRegistrationSubtotal = (receipt = {}) => {
    const { transaction = {} } = receipt;
    const { registrations = [] } = transaction;
    let subtotal = 0;

    if (Array.isArray(registrations)) {
        subtotal = registrations.reduce(
            (registrantsSubtotal = 0, registration = {}) => {
                const { participantTotal = 0.0 } = registration;
                return registrantsSubtotal + participantTotal;
            },
            0,
        );
    }

    return subtotal;
};
